var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvancesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.617,
    height: 21.238,
    viewBox: "0 0 19.617 21.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16261",
    "data-name": "Group 16261",
    transform: "translate(-8.26 -7)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18971",
    "data-name": "Path 18971",
    d: "M24.718,20.641a4.368,4.368,0,0,1,1.508.268V7H8.26V28.188H21.6a4.406,4.406,0,0,1,3.116-7.522ZM11.463,11.792H23.054v1.284H11.463Zm5.777,5.135H11.463V15.643H17.24Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18972",
    "data-name": "Path 18972",
    d: "M34.114,31.264a3.117,3.117,0,0,0-1.508-.38,3.16,3.16,0,1,0-.5,6.3,2.692,2.692,0,0,0,.5.05,2.591,2.591,0,0,0,.5-.05,3.108,3.108,0,0,0,1-.337,3.166,3.166,0,0,0,0-5.559Zm-1.926,4.9-2.025-2.013.891-.885,1.134,1.14,1.951-1.963.075-.075.891.879Z",
    transform: "translate(-7.888 -8.996)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancesIcon);
export default __webpack_public_path__ + "static/media/advances_icon.d9bd0df7c59b094b018ad5a149958a17.svg";
export { ForwardRef as ReactComponent };